<template>
  <va-edit-layout :title="title">
    <targets-form :id="id" :item="item" />
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
